module.exports = __webpack_public_path__ + "6de4a8975ed2e8fb6a0f1239d28ca52d.jpg";